import { useMemo } from "react";
import { motion } from "framer-motion";

// Slow floating dust/ember particles for premium ambient depth.
export const Particles = ({ count = 24 }) => {
  const dots = useMemo(
    () =>
      Array.from({ length: count }).map((_, i) => ({
        id: i,
        left: Math.random() * 100,
        top: Math.random() * 100,
        size: 1 + Math.random() * 2,
        drift: -30 + Math.random() * 60,
        duration: 8 + Math.random() * 10,
        delay: Math.random() * 6,
        opacity: 0.15 + Math.random() * 0.4,
      })),
    [count]
  );
  return (
    <div className="pointer-events-none absolute inset-0 overflow-hidden" data-testid="particles-layer">
      {dots.map((d) => (
        <motion.span
          key={d.id}
          className="absolute rounded-full bg-white"
          style={{ left: `${d.left}%`, top: `${d.top}%`, width: d.size, height: d.size, opacity: d.opacity }}
          animate={{ y: [0, -40, 0], x: [0, d.drift, 0], opacity: [d.opacity, d.opacity * 0.3, d.opacity] }}
          transition={{ duration: d.duration, delay: d.delay, repeat: Infinity, ease: "easeInOut" }}
        />
      ))}
    </div>
  );
};
